import React from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Bookshelf from './pages/Bookshelf';
import VisualMerchandising from './pages/VisualMerchandising';
import Design3D from './pages/Design3D';
import Branding from './pages/Branding';
import AboutUs from './pages/AboutUs';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bookshelf" element={<Bookshelf />} />
        <Route path="/visual-merchandising" element={<VisualMerchandising />} />
        <Route path="/3d-design" element={<Design3D />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
